/**
 * Timeline Carousel with Swiper.js
 * Smooth, touch-friendly, infinite looping carousel
 */

(function () {
    'use strict';

    function initSwiper() {
        const timelineCarousel = document.querySelector('.timeline-swiper');

        if (!timelineCarousel) {
            return;
        }

        // Check if Swiper is available
        if (typeof Swiper === 'undefined') {
            console.log('Swiper not loaded yet, waiting...');
            setTimeout(initSwiper, 100);
            return;
        }

        console.log('Initializing Swiper...');

        // Initialize Swiper
        const swiper = new Swiper('.timeline-swiper', {
            // Responsive breakpoints
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                991: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
            },

            // Auto height
            autoHeight: true,

            // Loop
            loop: true,
            loopAdditionalSlides: 2,

            // Speed
            speed: 600,

            // Navigation
            navigation: {
                nextEl: '.timeline-nav-next',
                prevEl: '.timeline-nav-prev',
            },

            // Pagination (for counter)
            pagination: {
                el: '.timeline-counter',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    return '<span class="timeline-counter-current">' + current + '</span> of <span class="timeline-counter-total">' + total + '</span>';
                }
            },

            // Touch/swipe
            touchRatio: 1,
            touchAngle: 45,
            grabCursor: true,

            // Accessibility
            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },

            // Events
            on: {
                init: function () {
                    console.log('Swiper initialized successfully');
                }
            }
        });
    }

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSwiper);
    } else {
        initSwiper();
    }

})();
